import React from 'react';
import "./style.css";

const Button = ({
  onClick,
  className = '',
  id = null,
  style = null,
  label = null
}) => {
  return /*#__PURE__*/React.createElement("button", {
    className: `button ${className}`,
    id: id,
    style: style,
    onClick: onClick
  }, label);
};

export default Button;